/**
 * @voltxampere/ui — Ceramic resonator (Sprint 45-6, placeholder)
 *
 * PLACEHOLDER. Düşük maliyetli quartz crystal alternatifi —
 * tolerance ±0.5% (vs ±20 ppm crystal), yerleşik load cap. Ucuz
 * MCU + remote control + low-precision clock.
 *
 * Reference: Generic ceramic resonator — Murata CSTLS_G serisi,
 * 4-20 MHz aralığı, ±0.5% tolerance, load cap entegre. ATmega328
 * (3-pin variant), ESP8266 backup clock, remote control transmitter.
 *
 *   Default mapping → inductor schemaType:
 *     inductance = 1e-3  (1 mH placeholder)
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const crystalCeramicResonator = {
    id: "ceramic-resonator",
    nameTr: "Seramik Rezonatör 8 MHz (Murata CSTLS, placeholder)",
    nameEn: "Ceramic Resonator 8 MHz (Murata CSTLS, placeholder)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "Y",
    defaultValue: "8MHz",
    schemaType: "inductor",
    defaultParams: { inductance: 1e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=crystal-ceramic-resonator.js.map